import React, { useState } from 'react';
import * as consts from 'config/consts';
import { IncomeGainItemProps } from 'pages/DividendDeposit';
import { ProductTypesLabel } from 'components/features/utils/productTypes';
import { formatNumber } from 'utils/formatter';

const DividendDetailItem = ({
  targetIncomeGain,
}: {
  targetIncomeGain: IncomeGainItemProps;
}) => {
  const isDataCooperation = /^MONO/.test(targetIncomeGain.isin);

  return (
    <>
      <div className="px-4 py-3 border-b border-gray-300">
        <div
          className="grid items-enter"
          style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div className="">
            {isDataCooperation ? (
              <div className="flex flex-row items-center text-red">
                <div className="icon-alert text-sm" />
                <div className="ml-1 text-xs">データ取得中</div>
              </div>
            ) : (
              <div className="flex flex-row">
                <ProductTypesLabel
                  productType={targetIncomeGain.productType}
                  cashMargin={consts.CashMargin.現物}
                />
                <div className="ml-1 text-xs text-bluegray-500">
                  {targetIncomeGain.symbol}
                </div>
              </div>
            )}
            <div className="flex flex-col line-clamp-2">
              <div
                className={`mt-2 font-bold ${
                  isDataCooperation ? 'text-bluegray-300' : 'text-bluegray-700'
                }`}>
                {targetIncomeGain.symbolName}
              </div>
            </div>
          </div>
          <div className="flex flex-row items-center">
            <div className="ml-auto" style={{ whiteSpace: 'nowrap' }}>
              <div className="flex flex-col">
                <div
                  className={`${
                    isDataCooperation
                      ? 'text-bluegray-300'
                      : 'text-bluegray-700'
                  }`}>
                  {targetIncomeGain.amount === null
                    ? '---'
                    : formatNumber(targetIncomeGain.amount, {})}
                  <span className="ml-1 text-xs">円</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const DividendList = ({
  incomeGainData,
}: {
  incomeGainData: IncomeGainItemProps[];
}) => {
  const [isShowAll, setIsShowAll] = useState<boolean>(false);
  const initialShowCount = 5;

  return (
    <>
      <div
        className="grid mt-4 px-4 py-1 text-sm text-bluegray-550 font-bold bg-gray-300"
        style={{ gridTemplateColumns: '1fr 1fr' }}>
        <div className="ml-2">銘柄</div>
        <div>入金額</div>
      </div>
      {incomeGainData.map((item, i) => {
        if (!isShowAll && initialShowCount <= i) return <></>;
        return (
          <DividendDetailItem
            {...{
              targetIncomeGain: item,
            }}
            key={i}
          />
        );
      })}
      {!isShowAll && initialShowCount < incomeGainData.length ? (
        <>
          <div
            className="flex flex-row items-center justify-center py-3 text-gray-500 cursor-pointer"
            onClick={() => setIsShowAll(prev => !prev)}>
            <div className="icon-chevron-down text-lg" />
            <div className="ml-1 text-sm">さらに表示</div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
